// extracted by mini-css-extract-plugin
export var aboutWorkshop = "style-module--about-workshop--a52cc";
export var aboutWorkshop__img = "style-module--about-workshop__img--7b38d";
export var aboutWorkshop__info = "style-module--about-workshop__info--d2366";
export var aboutWorkshop__item = "style-module--about-workshop__item--fdb18";
export var aboutWorkshop__title = "style-module--about-workshop__title--0410a";
export var aboutWorkshop__wrap = "style-module--about-workshop__wrap--5a639";
export var rocket = "style-module--rocket--b1ec8";